<template>
  <div class="pc-map">
    <div id="myMap"></div>
  </div>
</template>

<script>
import mapBase from "@/mixins/Nodes/map.js";
export default {
  mixins: [mapBase]
};
</script>

<style lang="scss" scoped>
.pc-map {
  #myMap {
    height: 768px;
  }
}
</style>

